import React from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useMapContextStore } from "../../../context/MapContext";
import {
  MetricCategory,
  MetricCategoryNamesMap,
} from "../../../types/data/dataTypes";

interface MetricSelectionProps {
  options: MetricCategory[];
}

export const MetricSelection: React.FC<MetricSelectionProps> = ({
  options,
}) => {
  const { metricCategory, setMetricCategory } = useMapContextStore(
    (store) => store,
  );
  if (!metricCategory)
    return (
      <>
        <Typography sx={{ fontStyle: "italic" }}>Choose a metric:</Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            alignItems: "center",
          }}
        >
          {options.map((metric) => (
            <Button
              key={metric}
              sx={{ width: "75%" }}
              variant="outlined"
              onClick={() => setMetricCategory(metric)}
            >
              {MetricCategoryNamesMap[metric]}
            </Button>
          ))}
        </Box>
      </>
    );
  return (
    <FormControl color="secondary" fullWidth sx={{ mt: 1 }}>
      <InputLabel color="secondary" id="demo-multiple-name-label">
        Metric
      </InputLabel>
      <Select
        color="secondary"
        id="metric-select"
        value={metricCategory}
        onChange={(e) => setMetricCategory(e.target.value as MetricCategory)}
        label="metric"
      >
        {options.map((metric) => (
          <MenuItem key={metric} value={metric}>
            {MetricCategoryNamesMap[metric]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
